import React from "react";
import { Icon } from "@iconify-icon/react";

const HrIcon = () => {
  return (
    <Icon icon="lucide:file-text" data-testid={`view-hr-action-iconify-btn`} />
  );
};

export default HrIcon;
